export function cn(...inputs) {
    const result = []

    for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i]

        if (!input) continue

        const type = typeof input

        if (type === 'string' || type === 'number') {
            result.push(input)
        } else if (Array.isArray(input)) {
            for (let j = 0; j < input.length; j++) {
                const item = input[j]
                if (!item) continue

                const itemType = typeof item

                if (itemType === 'string' || itemType === 'number') {
                    result.push(item)
                } else if (Array.isArray(item)) {
                    inputs.push(item) // flatten
                } else if (itemType === 'object') {
                    for (const key in item) {
                        if (item.hasOwnProperty(key) && item[key]) {
                            result.push(key)
                        }
                    }
                }
            }
        } else if (type === 'object') {
            for (const key in input) {
                if (input.hasOwnProperty(key) && input[key]) {
                    result.push(key)
                }
            }
        }
    }

    return result.join(' ')
}
